// extracted by mini-css-extract-plugin
export var brand = "_1t-9";
export var button = "_1t-0";
export var chevron = "_1t-v";
export var chevronButton = "_1t-w";
export var content = "_1t-n";
export var danger = "_1t-g";
export var dangerOutlined = "_1t-h";
export var dark = "_1t-l";
export var darkTheme = "_1t-c";
export var extraSmall = "_1t-4";
export var fullWidth = "_1t-8";
export var ghost = "_1t-d";
export var gray = "_1t-t";
export var icon = "_1t-p";
export var iconButton = "_1t-s";
export var iconButtonBorder = "_1t-x";
export var iconButtonBorderDark = "_1t-y";
export var iconButtonBorderLight = "_1t-z";
export var iconLeft = "_1t-q";
export var iconRight = "_1t-r";
export var large = "_1t-1";
export var light = "_1t-m";
export var medium = "_1t-2";
export var micro = "_1t-5";
export var nano = "_1t-7";
export var outlined = "_1t-k";
export var pending = "_1t-a";
export var primary = "_1t-i";
export var shadow = "_1t-o";
export var small = "_1t-3";
export var solidLight = "_1t-e";
export var solidLightBrand = "_1t-f";
export var spinner = "_1t-u";
export var transparent = "_1t-j";
export var warning = "_1t-b";
export var wideNano = "_1t-6";